import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"margin-left":"auto","margin-right":"auto","padding":"8px","width":"100%","display":"block","overflow":"auto"},
  class: "bracket"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"darkblue !important"},
  href: "https://twitch.tv/backgroundgaming_"
}, "backgroundgaming_", -1)

import { onMounted, ref, onUnmounted } from 'vue';
import Bracket from '../components/Bracket.vue';
import { bracketService } from '../services/bracket.service';
import { userService } from '@/services/user.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BracketView',
  setup(__props) {

let snackbar = ref(false);
let voteString = ref('');

//32 man
const bracket = ref(null);
let sub = bracketService.getBracket().subscribe((newBracket) => {
    bracket.value = newBracket;
});

let tempVotesSub = bracketService.getTempVotes().subscribe((votes) => {
    voteString.value = votes.join(' ');
});

let loggedIn = ref(!!userService.jwt);
let notLoggedIn = ref(!userService.jwt);

let userSub = userService.getCurrentUser().subscribe((user) => {
    loggedIn.value = !!user;
    notLoggedIn.value = !user;
});

function copy() {
    navigator.clipboard.writeText(`!bracket ${voteString.value}`);
    snackbar.value = true;
}

onUnmounted(() => {
    sub?.unsubscribe();
    userSub?.unsubscribe();
    tempVotesSub?.unsubscribe();
});

async function login() {
    localStorage.setItem('authFailedPath', JSON.stringify({ path: '/bracket' }));
    // const data = await router.push('login');
    // alert(JSON.stringify(data));
    location.href = '/login';
}

async function setup() {
    console.log('started');
}

onMounted(async () => {
    setup();
});


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(loggedIn))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, [
            _createVNode(_component_v_snackbar, {
              modelValue: _unref(notLoggedIn),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(notLoggedIn) ? (notLoggedIn).value = $event : notLoggedIn = $event)),
              "multi-line": "",
              timeout: 99999999
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createVNode(_component_v_btn, { onClick: login }, {
                    default: _withCtx(() => [
                      _createTextVNode("Login")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" to vote")
                ]),
                _createTextVNode(),
                _createElementVNode("span", null, [
                  _createTextVNode(" - or use twitch chat commmand \"!bracket " + _toDisplayString(_unref(voteString) || '<vote_number>') + "\" ", 1),
                  (_unref(voteString))
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        size: "x-small",
                        onClick: copy
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { icon: "mdi-content-copy" }),
                          _createVNode(_component_v_snackbar, {
                            modelValue: _unref(snackbar),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(snackbar) ? (snackbar).value = $event : snackbar = $event)),
                            "multi-line": "",
                            timeout: 500
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Copied! ")
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" on "),
                  _hoisted_3
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (bracket.value)
      ? (_openBlock(), _createBlock(Bracket, {
          key: 1,
          bracket: bracket.value
        }, {
          game: _withCtx(({ game }) => [
            _createTextVNode(_toDisplayString(game), 1)
          ]),
          _: 1
        }, 8, ["bracket"]))
      : _createCommentVNode("", true)
  ]))
}
}

})